import { NavigationGroup } from '../sidebar-admin-default/sidebar.model'

export const clientAdminNavigationGroups: NavigationGroup[] = [
    {
        label: 'Dashboard',
        icon: 'lucideLayoutDashboard',
        expanded: true,
        items: [
            {
                label: 'Admin Dashboard',
                icon: 'lucideShieldCheck',
                routerLink: '/client-admin',
            },
        ],
    },
    {
        label: 'Management',
        icon: 'lucideSettings',
        expanded: true,
        items: [
            {
                label: 'All Users',
                icon: 'lucideUsers',
                routerLink: '/client/users',
            },
            {
                label: 'Signup Access Control',
                icon: 'lucideShieldCheck',
                routerLink: '/client/signup-access-control',
            },
            {
                label: 'Raffles',
                icon: 'lucideTicket',
                routerLink: '/client/raffle',
            },
        ],
    },
]

export const clientMemberNavigationGroups: NavigationGroup[] = [
    {
        label: 'Dashboard',
        icon: 'lucideLayoutDashboard',
        expanded: true,
        items: [
            {
                label: 'Member Dashboard',
                icon: 'lucideLayoutDashboard',
                routerLink: '/client/dashboard',
            },
        ],
    },
    {
        label: 'Benefits & Rewards',
        icon: 'lucideGift',
        expanded: true,
        items: [
            {
                label: 'Deals',
                icon: 'lucideGift',
                routerLink: '/client/deals',
            },
            {
                label: 'My Claimed Benefits',
                icon: 'lucideShoppingCart',
                routerLink: '/client/claimed-items',
            },
            {
                label: 'Raffles',
                icon: 'lucideTicket',
                routerLink: '/client/raffle',
            },
            {
                label: 'My Profile',
                icon: 'lucideUser',
                routerLink: '/client/profile',
            },
        ],
    },
]

export const clientNavigationGroups: NavigationGroup[] =
    clientAdminNavigationGroups
